// refsContext.js
import { createContext } from "react";

const RefsContext = createContext();

export default RefsContext;
